import {
	mapActions,
	mapGetters
} from 'vuex';

import moment from 'moment';

import {
	EventBus
} from '@/support/event-bus';

import PageBar from '@/components/page-bar/page-bar';

import MedicineFilters from '@/domains/medicine/medicine-filters/medicine-filters';
import MedicineLabels from '@/domains/medicine/medicine-labels/medicine-labels';
import MedicinePending from '@/domains/medicine/medicine-pending/medicine-pending';
import MedicineHistory from '@/domains/medicine/medicine-history/medicine-history';

import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import state from './state';

export default {
	state,
	actions,
	mutations,
	getters,
	name: 'medicine',
	components: {
		MedicineFilters,
		MedicineLabels,
		MedicinePending,
		MedicineHistory,
		PageBar
	},
	data: () => ({
		datepicker: {
			today: new Date(),
			selected: new Date()
		},
		student: ''
	}),
	computed: {
		...mapGetters({
			user: 'getLoggedUser',
			history: 'medicineHistory',
			pending: 'medicinePending'
		})
	},
	methods: {
		...mapActions([
			'setBreadcrumb',
			'getMedicine',
			'getMedicineIsTaken',
			'setMedicineHistory',
			'setMedicinePending'
		]),
		retriveMedicineList(user, date, studentName) {

			return this.getMedicine({
				user: user.id,
				filter: {
					date,
					studentName
				}
			}).then((response) => {

				this.getMedicineIsTaken(true).then((response) => {
					this.setMedicineHistory(response);
				});

				this.getMedicineIsTaken(false).then((response) => {
					this.setMedicinePending(response);
				});

				EventBus.$emit('medicineListRetrived');

				return response;

			});

		}
	},
	mounted() {

		this.setBreadcrumb([{
			text: 'Dia a dia'
		}, {
			text: 'Medicações'
		}]);

		EventBus.$on('medicineListChange', () => {

			this.retriveMedicineList(
				this.user,
				moment(this.datepicker.selected).format('YYYY-MM-DD'),
				this.student
			);

		});

		this.retriveMedicineList(
			this.user,
			moment(this.datepicker.selected).format('YYYY-MM-DD'),
			this.student
		);

	},
	beforeDestroy() {

		EventBus.$off('medicineListRetrived');
		EventBus.$off('medicineListChange');

	}
};



// WEBPACK FOOTER //
// ./sources/app/medicine/index.js